import { Injectable } from '@angular/core';
import { CanActivate, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { RoleHomeService } from '../services/role-home.service';

/**
 * Unknown URLs: guests → login, signed-in users → their role home.
 */
@Injectable({
  providedIn: 'root',
})
export class FallbackRedirectGuard implements CanActivate {
  constructor(private roleHome: RoleHomeService) {}

  canActivate(): Observable<UrlTree> {
    return this.roleHome.homeUrlTree();
  }
}
